/* mjade-card-color — 사진이 바뀌면 아래 스와치 표시도 따라간다 (2026-09-01)
 * 테마 함수를 갈아끼우지 않는다. 사진의 --active 클래스 변화만 지켜본다.
 * 같은 색의 다른 컷으로 넘어갔을 때는 표시를 그대로 둔다(색이 안 바뀌었으므로).
 * 되돌리기: theme.liquid 의 script 한 줄 삭제.
 */
(function(){
  "use strict";
  if (window.__mjCardColor) return;
  window.__mjCardColor = true;
  var ON = "product-block-options__item--mj-on";
  function sync(card){
    var act = card.querySelector(".product-block__image--active");
    if (!act) return;
    var id = act.getAttribute("data-media-id");
    var items = card.querySelectorAll(".product-block-options__item[data-media]");
    var hit = null, i;
    for (i = 0; i < items.length; i++) {
      if (items[i].getAttribute("data-media") === id) { hit = items[i]; break; }
    }
    if (!hit) return;
    for (i = 0; i < items.length; i++) items[i].classList.toggle(ON, items[i] === hit);
    /* * 2026-09-01 — 몰의 «선택 줄» 도 같은 자리로 옮긴다.
       줄을 그리는 규칙은 theme.liquid 에만 있다. 여기서 다시 그리지 않고 부른다.
       (PC 화살표는 스와치를 안 누르므로 그쪽 click 처리로는 안 옮겨진다) */
    if (typeof window.__mjSwatchMark === "function") {
      try { window.__mjSwatchMark(hit); } catch (e) {}
    }
  }
  function watch(card){
    if (card.__mjWatched) return;
    card.__mjWatched = true;
    /* ★ 2026-09-02(2차) — 사진 요소를 «하나씩» 보지 않고 상자를 통째로 본다.
       나머지 색 사진은 손이 닿을 때 새로 만들어 붙는데, 예전처럼 요소마다
       감시를 걸면 «그때 있던 것만» 보게 돼 새로 만든 사진의 켜짐을 놓친다. */
    var box = card.querySelector(".image-cont") || card;
    var mo = new MutationObserver(function(){ sync(card); });
    mo.observe(box, { attributes: true, attributeFilter: ["class"], subtree: true });
  }
  /* ===== 2026-09-02 · 사진을 «필요할 때» 깨운다 =========================
     왜: 색깔별 카드로 쪼갠 뒤 한 카드가 모든 색 사진을 다 갖고 있다. 화면에
     안 보여도 lazy 라 스크롤이 닿으면 전부 내려받았다 — /collections/best 를
     끝까지 내리면 359장 17.6MB [2026-09-02 실측].
     product-block.liquid 가 대표 사진 말고는 loading:'manual' 로 내보낸다.
     manual 은 테마의 방식이라 src 대신 data-manual-src 로 나가 «안 받는다».
     여기서 깨우는 규칙만 정한다:
       · 카드에 손이 닿으면(마우스·손가락·키보드) 그 카드를 통째로 깨운다
       · 마우스가 있는 기기는 카드가 화면에 들어올 때 «둘째컷» 만 미리 깨운다
         (롤오버가 지금처럼 즉시 떠야 하므로)
     ★ 테마 함수에 기대지 않는다 — main.js 가 늦게 붙어도 되게 같은 일을 직접 한다. */
  function lift(img){
    if (!img.dataset.manualSrc) return;
    img.src = img.dataset.manualSrc;
    img.removeAttribute("data-manual-src");
    if (img.dataset.manualSrcset){
      img.srcset = img.dataset.manualSrcset;
      img.removeAttribute("data-manual-srcset");
    }
  }
  /* ★ 2026-09-02(2차) — 짧은 자료로 실린 «나머지 색 사진» 을 진짜 사진으로 만든다.
     자료 한 줄: <미디어id>~<주소>  (product-block.liquid 가 낸다.
       폭·높이는 안 싣는다 — 복제하는 대표컷의 값과 비율 감싸개가 자리를 잡아 준다)
     ★ 마크업을 손으로 짓지 않고 «이미 있는 대표컷을 복제» 한다 —
       테마가 기대하는 껍데기(img-ar 감싸개·클래스·sizes)를 그대로 물려받게.
     ★ 만든 뒤에는 테마가 init 때 한 번 잡아 둔 card.images 를 다시 채운다.
       그 배열은 스와치를 눌렀을 때 «어느 사진을 켤지» 찾는 데 쓰이므로,
       새로 만든 사진이 거기 없으면 색이 안 바뀐다. */
  function buildRest(card){
    var host = card.querySelector(".mj-rest");
    if (!host) return;
    var data = host.getAttribute("data-mj-rest") || "";
    var tmpl = card.querySelector(".product-block__image--primary");
    if (!tmpl){ host.parentNode.removeChild(host); return; }
    var parent = tmpl.parentNode;
    var frag = document.createDocumentFragment();
    data.split("|").forEach(function(row){
      if (!row) return;
      var p = row.split("~");
      if (p.length < 2 || !p[0] || !p[1]) return;
      var d = tmpl.cloneNode(true);
      d.className = "product-block__image product-block__image--secondary";
      d.setAttribute("data-media-id", p[0]);
      var img = d.querySelector("img");
      if (img){
        var sep = p[1].indexOf("?") < 0 ? "?" : "&";
        img.removeAttribute("data-manual-src");
        img.removeAttribute("data-manual-srcset");
        /* 폭 후보는 대표컷과 같은 기준 — 600px(480w) · 925px(740w).
           400px 칸에 2배 화면이어도 800px 이면 충분하다 [2026-09-02 실측]. */
        img.setAttribute("src", p[1] + sep + "width=600");
        img.setAttribute("srcset",
          p[1] + sep + "width=600 480w, " + p[1] + sep + "width=925 740w");
        img.setAttribute("loading", "lazy");
        if (p[2]) img.setAttribute("width", p[2]);
        if (p[3]) img.setAttribute("height", p[3]);
      }
      frag.appendChild(d);
    });
    parent.appendChild(frag);
    host.parentNode.removeChild(host);
    if (Array.isArray(card.images)){
      card.images = Array.prototype.slice.call(
        card.querySelectorAll(".product-block__image"));
    }
  }
  /* ★ 2026-09-02 — 손이 닿은 카드에서 «바로 다음에 보게 될» 두 장을 먼저 받는다.
     밀기는 손을 뗀 직후 시작하므로 그 두 장이 늦으면 미끄러짐이 기다린다(흰 칸 방지).
     나머지는 평소 순위 그대로 — 지금 보고 있는 사진과 자리를 다투지 않게. */
  function rush(card){
    var all = card.querySelectorAll(".product-block__image");
    var at = -1, i;
    for (i = 0; i < all.length; i++){
      if (all[i].classList.contains("product-block__image--active")){ at = i; break; }
    }
    if (at < 0) return;
    for (i = 1; i <= 2; i++){
      var el = all[(at + i) % all.length];
      var img = el && el.querySelector("img");
      if (img && !img.complete){
        try { img.fetchPriority = "high"; } catch (e) {}
      }
    }
  }
  function wake(card){
    if (card.__mjWoke) return;
    card.__mjWoke = 1;
    buildRest(card);
    card.querySelectorAll("img[data-manual-src]").forEach(lift);
    rush(card);
  }
  /* 밖에서도 부를 수 있게 열어 둔다 (mjade-card-hint.js 가 쓴다).
     ★ 깨우는 규칙은 여기 한 곳에만 둔다 — 부르는 쪽에서 다시 짜지 않는다.
     2026-09-03: 힌트가 «다음 색 사진» 을 먼저 만들어 둬야 흰 칸이 안 지나간다. */
  window.__mjCardWake = wake;
  function wakeHover(card){
    if (card.__mjWokeHover) return;
    card.__mjWokeHover = 1;
    card.querySelectorAll(".mj-hover-shot img[data-manual-src]").forEach(lift);
  }
  function cardOf(t){
    return t && t.closest ? t.closest("product-block.product-block") : null;
  }
  function touch(e){ var c = cardOf(e.target); if (c) wake(c); }
  document.addEventListener("pointerover", touch, true);
  document.addEventListener("touchstart", touch, { capture: true, passive: true });
  document.addEventListener("focusin", touch, true);

  var canHover = false;
  try { canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches; }
  catch (e) {}
  var io = null;
  if (canHover && "IntersectionObserver" in window){
    io = new IntersectionObserver(function(rows){
      rows.forEach(function(r){
        if (!r.isIntersecting) return;
        wakeHover(r.target);
        io.unobserve(r.target);
      });
    }, { rootMargin: "200px 0px" });
  }

  function init(){
    document.querySelectorAll("product-block.product-block").forEach(function(card){
      watch(card);
      if (io && !card.__mjWokeHover) io.observe(card);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
  window.addEventListener("load", init);
})();
